<br><br><br>

<div class="container report-layout-container" style="display: flex; align-items: flex-start; gap: 180px;">
  <table class="table-custom">
    <tbody>
    <br><br>
    <tr>
      <td class="heading" style="white-space: nowrap;">{{'Reporting Period From'|translate}}<span style="color: red;">*</span></td>
      <td class="date-input-and-error-cell">
        <div class="date-input-container">
          <input type="text" #dp1="bsDatepicker" bsDatepicker placement="right" [bsConfig]="bsConfig" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange()" readonly>
        </div>
        <div *ngIf="showFromDateError" class="error-message-right">{{fromDateErrorMessage}}</div>
      </td>
    </tr>
    <tr>
      <td class="heading" style="white-space: nowrap;">{{'Reporting Period To'|translate}}<span style="color: red;">*</span></td>
      <td class="date-input-and-error-cell">
        <div class="date-input-container">
          <input type="text" #dp2="bsDatepicker" bsDatepicker placement="right"
                 [bsConfig]="bsConfigToDate"
                 [(ngModel)]="toDate"
                 (ngModelChange)="onToDateChange()"
                 readonly>
        </div>
        <div *ngIf="showToDateError" class="error-message-right">{{toDateErrorMessage}}</div>
      </td>
    </tr>
    <tr>
      <td></td>
      <td style="position: relative;">
        <input type="button" value="{{'Generate Report'|translate}}" (click)="downloadReport(apiErrorPopup)">

        <ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" color="#003478" size="medium"
                     type="ball-spin-clockwise" class="report-button-spinner">
          <p style="font-size: 14px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;">Working on to download reports</p>
        </ngx-spinner>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="image-with-stacked-title">
    <h6>{{'Report of the number of times the below '}}</h6>
    <h6> {{ 'error message is displayed to the technician'}}</h6>
    <img src="assets/images/technical-problem.jpg" style="max-width: 500px; height: auto;">
  </div>

</div>

<ng-template #apiErrorPopup let-c="close" let-d="dismiss">
  <div class="container">
    <div class="row popup-header">
      <div class="padding-popup-header">{{'Download Report'|translate}}</div>
      <span class="cross-button" title="{{'close'|translate}}"><i class="fa fa-times" aria-hidden="true"
                                                                  (click)="d('Cross click')"></i></span>
    </div>
    <div class="row popup-text1">
      <div class="col-md-12">
        {{'Error Generating Report'|translate}}.
      </div>
    </div>
    <div class="row popup-text2">
      <div class="col-md-12">
        {{'Please try again later'|translate}}.
      </div>
    </div>
    <hr class="hr-line">
    <div class="row">
      <div class="col-md-12">
        <button class="btn shadow-none popup-button"
                (click)="c('Cross click')">{{'CLOSE'|translate}}</button>
      </div>
    </div>
  </div>
</ng-template>
